export const MIS_SUMMARY_INDEX = {
  ORG_ID_INDEX: {
    NAME: 'orgIdIndex',
    KEY: 'orgId',
  },
};

export const MIS_METADATA_INDEX = {
  ORG_ID_INDEX: {
    NAME: 'orgIdIndex',
    KEY: 'orgId',
  },
  DATE_INDEX: {
    NAME: 'dateIndex',
    KEY: 'date',
  },
};

export const MIS_COMPLIANCE_INDEX = {
  ORG_ID_INDEX: {
    NAME: 'orgIdIndex',
    KEY: 'orgId',
  },
};

export const INVOICE_SUMMARY_INDEX = {
  ORG_ID_DATE_INDEX: {
    NAME: 'orgIdDateIndex',
    KEY: ['orgId', 'invoiceDate'],
  },
  ORG_ID_INVOICE_ID_INDEX: {
    NAME: 'orgIdInvoiceIdIndex',
    KEY: ['orgId','invoiceId'],
  }
};

export enum CursorAccess {
  READ_WRITE = 'readwrite',
  READ_ONLY = 'readonly',
}

export enum QueryType {
  ONLY = 'ONLY',
  BOUND = 'BOUND',
}

export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
